import { ajax } from "../utils/ajax";
import { ADSERVER_CONFIG_ENDPOINT, TENANTS_LIST } from "../Common Components/service.urls";

export const getAdServerConfigsList = (name,clientName,os) => {
  name = name !== '' ? `name=${name}` : name;

  return ajax({
    method:"get",
    url:`${ADSERVER_CONFIG_ENDPOINT}/list?${name}&${os}`
  })
}

export const getTenantsList = (tenantId) => {
  return ajax({
    method:"get",
    url:`${TENANTS_LIST}/${tenantId}`
  })
}

export const getAdServerConfigById = (id) => {
  return ajax({
    method:"get",
    params:{
      id
    },
    url:`${ADSERVER_CONFIG_ENDPOINT}`
  })
}

export const saveAdServerConfig = (adserverconfig ,method) => {
  return ajax({
    method : method,
    data : adserverconfig ,
    url : `${ADSERVER_CONFIG_ENDPOINT}`
  })
}
export const deleteServerConfigById = (id) => {

  return ajax({
    method:"delete",
    url:`${ADSERVER_CONFIG_ENDPOINT}/${id}`
  })
}

export const getAdServerAuditsById = (id) => {
  return ajax({
    method : "get",
    params :{
      adServerConfigId: id
    },
    url : `${ADSERVER_CONFIG_ENDPOINT}/audits`

  })
}